import { Component, HostListener, OnInit } from '@angular/core';
import { AdminComponent } from '../admin.component';
import { AdminService } from '../services/admin.service';

@Component({
  selector: 'app-business-management',
  templateUrl: './business.management.component.html',
  styleUrls: ['./business.management.component.scss']
})
export class BusinessManagementComponent extends AdminComponent implements OnInit {
  pageTitle: string = "Admin";

  constructor(adminService: AdminService) {
    super(adminService);
  }

  ngOnInit(): void {
    super.ngOnInit();
  }
}
